import React from "react";
import { inject, observer } from "mobx-react";
import AppDrawer from "components/AppDrawer/AppDrawer";
import UserForm from "components/Admin/UserForms/UserForm";
import CreditForm from "components/Admin/UserForms/CreditsFrom";
import PurchaseOrdersFrom from "components/Admin/UserForms/PurchaseOrdersFrom";
import SpecialPlanFrom from "components/Admin/UserForms/SpecialPlanFrom";
import TokenTable from "components/Admin/AdminTable/TokenTable";
import SenderIdForm from "components/Admin/UserForms/SenderIdForm";
import ViewInvoice from "./ViewInvoice";

const UserDrawer = props => {
  const { visible, onClose, userStore, activeDrawer, userId } = props;
  const { selectedUser, addUser, updateUser, addCreditToUser, updateGatewayCreditForUser, fetchCurrencies, getUsersTokens, userSenderIds } = userStore;

  const getDrawerContent = () => {
    let method;
    if (activeDrawer === "add") {
      method = onAddUser;
    } else if (activeDrawer === "edit") {
      method = onUpdateUser;
    } else if (activeDrawer === "addMobileCredit") {
      method = addCredits;
    } else if (["addGatewayCredit", "deductGatewayCredit", "balance", "specialPlans"].includes(activeDrawer)) {
      method = updateGatewayCredit;
    } else if (activeDrawer === "viewTokens") {
      method = getUsersTokens;
    }
    if (["add", "edit", "view"].includes(activeDrawer)) {
      return <UserForm onClose={onClose} onSubmit={method} user={userStore.selectedUser} readMode={activeDrawer === "view"} fetchCurrencies={fetchCurrencies} />;
    } else if (["addGatewayCredit", "deductGatewayCredit", "addMobileCredit"].includes(activeDrawer)) {
      return (
        <CreditForm
          onClose={onClose}
          onSubmit={method}
          user={selectedUser}
          gateway={activeDrawer == "addMobileCredit" ? false : true}
          type={activeDrawer == "addGatewayCredit" ? "inc" : "dec"}
          buttonMessage={activeDrawer == "addMobileCredit" ? "Add Mobile Credit" : activeDrawer == "addGatewayCredit" ? "Add Gateway Credit" : "Deduct Gateway Credit"}
        />
      );
    } else if (activeDrawer === "balance") {
      return <PurchaseOrdersFrom onClose={onClose} onSubmit={method} user={selectedUser} />;
    } else if (activeDrawer === "specialPlans") {
      return <SpecialPlanFrom user={selectedUser} />;
    } else if (activeDrawer === "viewTokens") {
      return <TokenTable onSubmit={method} user={selectedUser} />;
    } else if (activeDrawer === "senderid") {
      return <SenderIdForm onClose={onClose} user={selectedUser} userSenderIds={userSenderIds} />;
    }
    // else if (activeDrawer === "viewInvoice") return <ViewInvoice userId={userId} />;
  };

  const onAddUser = user => {
    return addUser(user);
  };

  const onUpdateUser = user => {
    return updateUser(user);
  };

  const addCredits = (userId, credit) => {
    return addCreditToUser(userId, credit);
  };

  const updateGatewayCredit = (userId, params) => {
    return updateGatewayCreditForUser(userId, params);
  };

  const getDrawerTitle = () => {
    switch (activeDrawer) {
      case "add":
        return "Add User";
      case "edit":
        return "Edit User";
      case "view":
        return "User";
      case "addMobileCredit":
        return "Add Mobile Credit";
      case "addGatewayCredit":
        return "Add Gateway Credit";
      case "deductGatewayCredit":
        return "Deduct Gateway Credit";
      case "balance":
        return "Balance";
      case "specialPlans":
        return "Special Plans";
      case "viewTokens":
        return "User Tokens";
      case "senderid":
        return "Sender IDs";
      // case "viewInvoice":
      //   return "View Invoice";
      default:
        return "";
    }
  };

  return (
    <AppDrawer visible={visible} onClose={onClose} label={getDrawerTitle()} width={1000}>
      {getDrawerContent()}
    </AppDrawer>
  );
};

export default inject(stores => ({
  userStore: stores.store.userStore
}))(observer(UserDrawer));
